import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useSelectedTemplateId } from '../../hooks/useSelectedTemplateId';
import ConfigurationHeader from './ConfigurationHeader';
import { RoutingPage, setPage } from '../../routes/routerSlice';
import ApplicationClosedOverlay from '../../components/global/ContentOverlay/ApplicationClosedOverlay';
import TemplateStatusOverlay from '../../components/global/ContentOverlay/TemplateStatusOverlay';
import { MainContentWrapper } from '@ydistri/ds';
import { useAppDispatch } from '../../store';
import { useStableParams } from '../../routes/useStableParams';

export enum ConfigurationSubpage {
  GLOBAL = 'global',
  CATEGORIES = 'categories',
  REGIONS = 'regions',
  STORES_OLD = 'stores-old',
  STORES = 'stores',
  SKUCLASSES = 'skuclasses',
  PRODUCTLISTS = 'productlists',
  BRANDS = 'brands',
  ADVANCED = 'advanced',
  DRILLDOWN = 'drilldown',
}

const Configuration: React.FC = () => {
  const dispatch = useAppDispatch();
  const { projectShortName, templateId } = useStableParams();
  const selectedTemplateId = useSelectedTemplateId();

  useEffect(() => {
    dispatch(setPage(RoutingPage.CONFIGURATION));
  }, [dispatch]);

  if (!templateId && selectedTemplateId && projectShortName) {
    return <Navigate to={`/${projectShortName}/configuration/${selectedTemplateId}`} />;
  }

  return (
    <>
      <ConfigurationHeader />
      <MainContentWrapper>
        <Outlet />
        <TemplateStatusOverlay />
      </MainContentWrapper>
      <ApplicationClosedOverlay />
    </>
  );
};

export default Configuration;
